/**
 * @module app.fm
 * @preferred
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule, DynamicViews } from 'app/shared/config/modules';
import { IAppRouteConfig } from 'app/shared/config/router-types';
import { NavigationInstruction } from 'aurelia-router';
import { FaxService } from 'app/fm/services/fax-service';
import { getFaxManagementQueueNavigationTypes } from 'app/fm/components/queues/queue-navigation-types';


@autoinject()
export class FaxManagementModule extends AppModule {

    public readonly code = 'fm';

    constructor(private readonly logger: AppLogger, private readonly faxService: FaxService) {
        super();

        logger.source = this;
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['fm'];
    }

    public getRoutes(): ReadonlyArray<IAppRouteConfig> {
        return [
            { route: 'fm/queues/fax/:queueId', name: 'fm.queues.fax', navigationStrategy: instruction => this.navigateToFaxQueue(instruction), settings: { topic: 'fm.queues.fax', bypassAuthentication: true } },
            { route: 'fm/admin/fax-notes', name: 'fm.admin.fax-notes', moduleId: PLATFORM.moduleName('app/fm/pages/admin/manage-fax-notes-page'), title: 'fm.admin.fax-notes', settings: { topic: 'fm.admin.fax-notes' } },
            { route: 'fm/admin/fax-queues', name: 'fm.admin.fax-queues', moduleId: PLATFORM.moduleName('app/fm/pages/admin/manage-fax-queues-page'), title: 'fm.admin.fax-queues', settings: { topic: 'fm.admin.fax-queues' } },
            { route: 'fm/document/:documentId', name: 'fm.document', moduleId: PLATFORM.moduleName('app/fm/pages/fax-document-page'), title: 'fm.document', settings: { topic: 'fm.document' } },
            { route: 'fm/admin/fax-accounts', name: 'fm.admin.fax-accounts', moduleId: PLATFORM.moduleName('app/fm/pages/admin/manage-fax-accounts-page'), title: 'fm.admin.fax-accounts', settings: { topic: 'fm.admin.fax-accounts' } },
        ];
    }

    private async navigateToFaxQueue(instruction: NavigationInstruction): Promise<void> {
        const { queueId } = instruction.params;
        if(typeof queueId === 'string') {
            try {
                instruction.config.moduleId = PLATFORM.moduleName(`app/fm/pages/queues/fax-queue-page`);
                return;
            }
            catch(error) {
                this.logger.error(`Unable to navigate to Fax Queue: ${queueId}`);
            }
        }
        // redirect to not found page
        instruction.config.moduleId = PLATFORM.moduleName('app/shared/components/not-found');
    }

    public getDynamicViews(scope: string): DynamicViews {
        if(scope === 'Core.QueueType') {
            return getFaxManagementQueueNavigationTypes();
        }
        return {};
    }

}
